"use client";
import { jsxs as o, jsx as a } from "react/jsx-runtime";
const n = ({
  title: l,
  titleId: c,
  desc: r,
  descId: i,
  ...e
}) => /* @__PURE__ */ o(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    width: 24,
    height: 24,
    "aria-labelledby": c,
    "aria-describedby": i,
    ...e,
    children: [
      r ? /* @__PURE__ */ a("desc", { id: i, children: r }) : null,
      l ? /* @__PURE__ */ a("title", { id: c, children: l }) : null,
      /* @__PURE__ */ a(
        "path",
        {
          stroke: "currentColor",
          strokeWidth: 0.4,
          d: "M13.371 10.8a7.545 7.545 0 0 0 3.12 4.46l.345 2.329.142 1.66c.001.018.004.035.006.053a3.063 3.063 0 0 0 6.038-.06l.12-1.615.347-2.357c2.324-1.59 4.151-4.787 2.86-8.197-3.364-8.227-14.491-4.285-12.978 3.727ZM20 20.594a1.82 1.82 0 0 1-1.805-1.787h3.608A1.816 1.816 0 0 1 20 20.594Zm-2.067-16.43c3.4-1.243 6.137.546 7.239 3.326 1.146 3.044-.742 5.638-2.291 6.639a1.39 1.39 0 0 0-.629.958l-.352 2.4-.005.07h-3.808l-.01-.113-.35-2.367a1.357 1.357 0 0 0-.585-.931 5.652 5.652 0 0 1 .79-9.983ZM16.686 8.95a.625.625 0 0 1 .884-.883l2.43 2.43 2.43-2.43a.625.625 0 0 1 .884.884l-2.69 2.689v4.05a.625.625 0 0 1-1.25 0v-4.05zM10.63 37.317a.625.625 0 0 0 .88.003l1.81-1.777c5.867-.046 9.752-.06 11.017.002a4.943 4.943 0 0 0 3.692-1.434l7.168-8.32a1.185 1.185 0 0 0 .212-1.195 1.324 1.324 0 0 0-1.011-.819 2.981 2.981 0 0 0-2.546.613l-6.117 4.981c-.405.33-.912.51-1.434.51h-4.914c-.282.055-.477-.075-.497-.164a.738.738 0 0 1 .858-.993c1.737.269 4.558.323 5.476-1.127.949-1.564-.572-3.89-2.78-3.414-1.516.28-3.074.222-4.566-.168a6.027 6.027 0 0 0-7.924 1.338c-.277.377-1.158 1.064-2.595 2.534l-2.66 2.608a.625.625 0 0 0-.004.887zm.261-11.142a4.847 4.847 0 0 1 6.5-1.005c1.734.49 3.558.57 5.327.233a1.288 1.288 0 0 1 1.393.564c.48 1.2-.325 1.455-1.643 1.59-1.395.368-3.299-.706-4.38.547-1.068 1.172-.348 3.238 1.334 3.026h4.879c.81 0 1.595-.28 2.223-.79l6.12-4.982a1.735 1.735 0 0 1 1.446-.368c.041.01.087.017.125.027l-7.107 8.248a3.484 3.484 0 0 1-1.354.855c-.44.146-.903.206-1.366.176-1.308-.065-5.145-.05-11.33-.001a.625.625 0 0 0-.434.18l-1.548 1.52-5.05-5.05z"
        }
      )
    ]
  }
);
export {
  n as default
};
